import deviceMenu from '@js/common/deviceMenu.js';
// import { appendSVGBtn } from '@js/common/customFunctions.js';
deviceMenu();

/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    /* Process buttons */
    // document.querySelectorAll('.btn-link, .btn-play').forEach(function (element) {
    //     if (element.classList.contains('btn-link')) {
    //         appendSVGBtn(element, '#icon-btn-arrow', '24', '15');
    //     } else if (element.classList.contains('btn-play')) {
    //         appendSVGBtn(element, '#icon-play-btn', '10', '13');
    //     }
    // });
    /* Process buttons End */
    setHeaderHeight();
    updateHeader();

    /* Leadership start */

    const cards = document.querySelectorAll('.lb-left-card-content');

    cards.forEach(card => {
        const desc = card.querySelector('.lb-left-card-description');
        const btn = card.querySelector('.lb-read-more');

        if (!desc || !btn) {return;}

        const style = window.getComputedStyle(desc);
        const lineHeight = parseFloat(style.lineHeight); // line height in px
        const maxLines = 4;
        const maxHeight = lineHeight * maxLines;

        if (desc.scrollHeight > maxHeight) {
            // wrap text in a div
            const fullText = desc.innerHTML;
            desc.innerHTML = '';

            const visibleText = document.createElement('div');
            visibleText.classList.add('visible-text');
            visibleText.innerHTML = fullText;
            visibleText.style.maxHeight = maxHeight + 'px';
            visibleText.style.overflow = 'hidden';
            visibleText.style.transition = 'max-height 0.3s ease';
            desc.appendChild(visibleText);

            btn.style.display = 'inline-block';

            btn.addEventListener('click', () => {
                if (visibleText.style.maxHeight === maxHeight + 'px') {
                    // expand
                    visibleText.style.maxHeight = visibleText.scrollHeight + 'px';
                    btn.textContent = 'SHOW LESS';
                } else {
                    // collapse
                    visibleText.style.maxHeight = maxHeight + 'px';
                    btn.textContent = 'CONTINUE READING';
                }
            });
        }
    });

    /* Leadership end */

});
window.addEventListener('resize', () => {
    setHeaderHeight();
    updateHeader();
});

window.addEventListener('scroll', function() {
    if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
    }
});

/* Use jQuery code Start
------------------------------------------------------------------------------*/

(function($) {
    // Write code here

})(jQuery);

/* ------------------------------------------------------------------------------
Use jQuery code End */

// header height 
function setHeaderHeight() {
    const header = document.querySelector('header');
    const hero = document.querySelector('.main-content');

    if (header && hero) {
        const headerHeight = header.offsetHeight;
        // Set CSS variable on hero section
        hero.style.setProperty('--headerHeight', headerHeight + 'px');
    }
}

// Leadership Sticky
let lastScroll = 0;
let ticking = false;

function updateHeader() {
    const mainHeader = document.querySelector('.main-header');
    const leaderShipSticky = document.querySelectorAll('.leadership-block');
    if (!mainHeader) {return;}

    const currentScroll = window.scrollY;
    const realHeaderHeight = mainHeader.offsetHeight;

    mainHeader.classList.toggle('stuck', currentScroll > 0);

    if (currentScroll > lastScroll && currentScroll > 200) {
        mainHeader.classList.add('header-pinned');
    } else if (currentScroll < lastScroll) {
        mainHeader.classList.remove('header-pinned');
    }

    leaderShipSticky.forEach((section) => {
        if (
            mainHeader.classList.contains('header-pinned') &&
            !mainHeader.classList.contains('always-sticky')
        ) {
            section.style.setProperty('--header-height', '30px');
        } else {
            section.style.setProperty('--header-height', `${realHeaderHeight}px`);
        }
    });

    lastScroll = currentScroll;
    ticking = false;
}
